import { useState } from 'react';
import { validateSepaJson } from '../../../services/validationService';
import { validateSepaJson as validateCsvJson } from '../../../services/csvValidationService';
import type { FinancialAlerts } from '../../../types/validation';
import type { ParsedPain001 } from '../../../services/xmlParser';
import type { ParsedCsv } from '../../../services/csvParser';
import type { ValidationState } from '../types';

export function useValidation() {
  const [isValidating, setIsValidating] = useState<boolean>(false);
  const [evaluationResponse, setEvaluationResponse] = useState<any | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function runValidation(
    parsedJson: ParsedPain001 | ParsedCsv | null,
    selectedAlerts: string[],
    alertOptions: string[],
    selectedCountries?: string[]
  ): Promise<void> {
    if (!parsedJson) return;
    
    try {
      setIsValidating(true);
      setError(null);
      const alertsJson: FinancialAlerts = {
        selectedAlerts: selectedAlerts,
        alertOptions: alertOptions,
        selectedCountries: selectedCountries
      };
      
      // Detect CSV format (has payments array) vs XML format (has paymentInformation)
      const isCsv = 'payments' in parsedJson && Array.isArray(parsedJson.payments);
      const results = isCsv 
        ? await validateCsvJson(parsedJson.payments, alertsJson)
        : await validateSepaJson(parsedJson, alertsJson);
      
      setEvaluationResponse(results as any);
    } catch (e) {
      setEvaluationResponse(null);
      setError(e instanceof Error ? e.message : 'Failed to validate');
    } finally {
      setIsValidating(false);
    }
  }

  return {
    isValidating,
    evaluationResponse,
    error,
    runValidation,
    setError,
    setEvaluationResponse
  };
}

